import React from "react";
import { Outlet } from "react-router-dom";

/*
  Component to manage the entire CH_ELEMENTS section
*/
function Material() {
  return <Outlet />;
}

export default Material;
